import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  Autocomplete,
  Button,
  Card,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import SnackBarUI from "../../common/SnackUI";
import { useNavigate } from "react-router-dom";
import { uplodImageAction } from "../../redux/toolkit/image/uploadImage";
import { DevTool } from "@hookform/devtools";
import { appCategoryAction } from "../../redux/toolkit/apps/categories";
import AppbarUI from "../../common/AppbarUI";
import BodyWapperUI from "../../common/BodyWapperUI";
import DrawerUI from "../../common/DrawerUI";
import { addBankAction } from "../../redux/toolkit/accountDetail.jsx/addbank";

const app_schema = yup
  .object()
  .shape({
    holder_name: yup
      .string()
      .required("Holder Name is required.")
      .matches(
        /^[A-Za-z\s]+$/,
        "Holder Name should not contain numbers or special characters."
      ),
    account_no: yup
      .number()
      .typeError("Account Number must be a number")
      .required("Account Number is required.")
      .nullable(),
    account_type: yup.string().required("Account type is required"),
    bussiness_name: yup.string().required("Business Name is Required"),
    country: yup.string().required("Country is Required"),
    address: yup.string().required("address is Required"),
    address2: yup.string().required("address2 is Required"),
    city: yup.string().required("city is Required"),
    region: yup.string().required("Region is Required"),
    postal_code: yup
      .number()
      .typeError("Postal code must be a number")
      .required("Postal code is Required")
      .nullable(),
    branch: yup.string().required("Branch is Required"),
    ifcs_code: yup.string().required("IFSC Code is Required"),
  })
  .required();

export default function CreateBankDetail() {
  const {
    register,
    control,
    setError,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(app_schema),
    defaultValues: {},
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [accountType, setAccountType] = useState();
  const [error, setErrorr] = useState({
    postal_code: false,
  });
  const [snakebar, setSnakeBar] = useState(false);
  const appCategory = useSelector((state) => state.addBank);
  const { status, data, message, loading } = appCategory;
  const accTypeArr = ["Individual", "Business"];

  useEffect(() => {
    dispatch(appCategoryAction());
  }, [dispatch]);

  const platformArr = ["Android", "IOS", "Web"];

  const handleAppSubmit = async (data) => {
    const appStore = await dispatch(
      addBankAction({ ...data, account_type: accountType })
    );
    setSnakeBar(true);
    setTimeout(() => {
      navigate("/payouts");
    }, 2000);
  };

  return (
    <>
      <AppbarUI />
      <DrawerUI />
      <BodyWapperUI>
        {/* <Card sx={{ p: 5 }}>
          <Typography variant='h5' sx={{ mb: 5 }}>Add Bank Details</Typography>
          <form onSubmit={handleSubmit(handleAppSubmit)}>
            <Stack spacing={3}>
              <Stack direction="row" spacing={10} justifyContent="center" alignItems="center">
                <Autocomplete
                  disablePortal
                  options={accTypeArr}
                  onChange={(event, value) => {
                    setAccountType(value);
                    setValue('account_type', value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,

                    })
                  }
                  }

                  sx={{ width: 450 }}
                  renderInput={(params) => <TextField {...params} label="select Platform" error={errors?.account_type?.message} helperText={errors?.account_type?.message} />}
                />
                <TextField label="Holder Name" type='text' {...register('holder_name')} error={errors?.holder_name?.message} helperText={errors?.holder_name?.message} style={{ width: "450px" }} />
                <TextField label="Account Number" type='text' {...register('account_no')} error={errors?.account_no?.message} helperText={errors?.account_no?.message} style={{ width: "450px" }} />
              </Stack>

              <Stack direction="row" spacing={10} justifyContent="center" alignItems="center">
                <TextField label="IFSC code" {...register('ifcs_code')} error={errors?.ifcs_code?.message} helperText={errors?.ifcs_code?.message} style={{ width: "450px" }} />
                <TextField label="Business Name" {...register('bussiness_name')} style={{ width: "450px" }} error={errors?.bussiness_name?.message} helperText={errors?.bussiness_name?.message} />
                <TextField label="Country" {...register('country')} style={{ width: "450px" }} error={errors?.country?.message} helperText={errors?.country?.message} />
              </Stack>
              <Stack direction="row" spacing={10} justifyContent="center" alignItems="center">
                <TextField label="Address" {...register('address')} style={{ width: "450px" }} error={errors?.address?.message} helperText={errors?.address?.message} />
                <TextField label="Address 2" {...register('address2')} style={{ width: "450px" }} error={errors?.address2?.message} helperText={errors?.address2?.message} />
                <TextField label="city" {...register('city')} style={{ width: "450px" }} error={errors?.city?.message} helperText={errors?.city?.message} />
              </Stack>


              <Stack direction="row" spacing={10} justifyContent="center" alignItems="center">
                <TextField label="Region" {...register('region')} style={{ width: "450px" }} error={errors?.region?.message} helperText={errors?.region?.message} />
                <TextField inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} label="Postal code" {...register('postal_code')} style={{ width: "450px" }} error={errors?.postal_code?.message} helperText={errors?.postal_code?.message || error?.postal_code} />
                <TextField label="Branch" {...register('branch')} style={{ width: "450px" }} error={errors?.branch?.message} helperText={errors?.branch?.message} />
              </Stack>

              <Stack direction="row" spacing={10} justifyContent="center" alignItems="center">
              </Stack>

              <Stack direction='row' spacing={2}>
                <Button variant='contained' type='submit'>Submit</Button>
              </Stack>
            </Stack>
          </form>
        </Card> */}

        <Card sx={{ p: { xs: 2, sm: 5 } }}>
          <Typography variant="h5" sx={{ mb: 5 }}>
            Add Bank Details
          </Typography>

          <form onSubmit={handleSubmit(handleAppSubmit)}>
            <Stack spacing={3}>
              {/* Row 1 */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 3 }}
                justifyContent="center"
                alignItems="center"
              >
                <Autocomplete
                  disablePortal
                  options={accTypeArr}
                  onChange={(event, value) => {
                    setAccountType(value);
                    setValue("account_type", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Platform"
                      error={!!errors?.account_type}
                      helperText={errors?.account_type?.message}
                    />
                  )}
                />
                <TextField
                  label="Holder Name"
                  type="text"
                  {...register("holder_name")}
                  error={!!errors?.holder_name}
                  helperText={errors?.holder_name?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
                <TextField
                  label="Account Number"
                  type="text"
                  {...register("account_no")}
                  error={!!errors?.account_no}
                  helperText={errors?.account_no?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
              </Stack>

              {/* Row 2 */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 3 }}
                justifyContent="center"
                alignItems="center"
              >
                <TextField
                  label="IFSC Code"
                  {...register("ifcs_code")}
                  error={!!errors?.ifcs_code}
                  helperText={errors?.ifcs_code?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
                <TextField
                  label="Business Name"
                  {...register("bussiness_name")}
                  error={!!errors?.bussiness_name}
                  helperText={errors?.bussiness_name?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
                <TextField
                  label="Country"
                  {...register("country")}
                  error={!!errors?.country}
                  helperText={errors?.country?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
              </Stack>

              {/* Row 3 */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 3 }}
                justifyContent="center"
                alignItems="center"
              >
                <TextField
                  label="Address"
                  {...register("address")}
                  error={!!errors?.address}
                  helperText={errors?.address?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
                <TextField
                  label="Address 2"
                  {...register("address2")}
                  error={!!errors?.address2}
                  helperText={errors?.address2?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
                <TextField
                  label="City"
                  {...register("city")}
                  error={!!errors?.city}
                  helperText={errors?.city?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
              </Stack>

              {/* Row 4 */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 3 }}
                justifyContent="center"
                alignItems="center"
              >
                <TextField
                  label="Region"
                  {...register("region")}
                  error={!!errors?.region}
                  helperText={errors?.region?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
                <TextField
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  label="Postal Code"
                  {...register("postal_code")}
                  error={!!errors?.postal_code}
                  helperText={errors?.postal_code?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
                <TextField
                  label="Branch"
                  {...register("branch")}
                  error={!!errors?.branch}
                  helperText={errors?.branch?.message}
                  sx={{ width: { xs: "100%", sm: "32%" } }}
                />
              </Stack>

              {/* Submit Button */}
              <Stack direction="row" justifyContent="center">
                <Button 
                variant="contained" 
                type="submit"
                sx={{
                  background:"#000",
                  "&:hover":{
                    background:"#000"
                  }
                }}
                >
                  Submit
                </Button>
              </Stack>
            </Stack>
          </form>
        </Card>
      </BodyWapperUI>
      <SnackBarUI
        state={snakebar}
        setState={setSnakeBar}
        status={status}
        message={message}
      />
      <DevTool control={control} />
    </>
  );
}
